export function mapBoth(F) {
    return f => x => F.bimap(x, f, f);
}
